'use strict';

;(function ($) {
  $(document).ready(function () {
    // START slidebars setup
    var setupSlidebars = function () {
      var controller = new slidebars();
      var $toggle = $('.slidebar-toggle');
      var id = 'nav-sidebar';

      controller.init();

      $toggle.on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).toggleClass('is-active');
        controller.toggle(id);
      });
    }();
    // END slidebars setup

    // START search toggle
    var searchToggle = function () {
      var $toggle = $('.search-toggle');
      var $search = $('.search-wrapper');

      $toggle.on('click', function () {
        return $search.toggleClass('is-active');
      });
    }();
    // END search toggle

    // START sponsors carousel
    var sponsorsCarousel = function () {
      $('.sponsors-carousel').owlCarousel({
        loop: true,
        autoplay: true,
        autoplayTimeout: 8000,
        autoplayHoverPause: false,
        margin: 30,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
            nav: true
          },
          768: {
            items: 3,
            nav: false
          },
          1025: {
            items: 4,
            nav: false
          }
        }
      });
    }();
    // END sponsors carousel

    var viemoPlayer = function () {
      $('#P1').vimeo_player({
        containment: '#video-wrapper',
        ratio: '16/9', // "auto", "16/9", "4/3"
        videoURL: null,
        startAt: 0,
        stopAt: 0,
        autoPlay: true,
        vol: 50, // 1 to 100
        addRaster: false,
        opacity: 1,
        mute: false,
        loop: true,
        showControls: false,
        show_vimeo_logo: true,
        stopMovieOnBlur: true,
        realfullscreen: true,
        mobileFallbackImage: null,
        gaTrack: true,
        optimizeDisplay: true,
        mask: false,
        align: 'center,center', // top,bottom,left,right
        onReady: function onReady(player) {}
      });
    }();
  }); // END document ready
})(jQuery);